import { formatTimestamp } from "@/utils/formatTimestamp";

export const formatSoftPaywallExpirationTimestamp = (timestamp) => {
  if (!timestamp) {
    return "";
  }

  // Add 24 hours (86400000 milliseconds) to the timestamp
  const timestampPlus24Hours = parseInt(timestamp) + 86400000;

  return formatTimestamp(timestampPlus24Hours);
};
